import {UserType} from '../../shared/DTO/userType';
import {AgreementModel} from './agreement.model';
import {ContactModel} from './contact.model';
import {SubjectModel} from './subject.model';
import {SecurityInfoModel} from './security-info.model';
import {BaseModel} from '../../base/models/base-model.model';

export class IdentityModel extends BaseModel {
  private _agreements?: Array<AgreementModel>;
  private _alias?: string;
  private _contacts?: Array<ContactModel>;
  private _customerCodeCARA?: string;
  private _domain?: string;
  private _nickname?: string;
  private _password?: string;
  private _products?: Array<string>;
  private _roles?: Array<string>;
  private _securityInfo?: SecurityInfoModel;
  private _subject?: SubjectModel;
  private _userType?: UserType;

  constructor(agreements?: Array<AgreementModel>, alias?: string, contacts?: Array<ContactModel>, customerCodeCARA?: string, domain?: string, id?: string, nickname?: string, password?: string, products?: Array<string>, roles?: Array<string>, securityInfo?: SecurityInfoModel, subject?: SubjectModel, userType?: UserType) {
    super();
    this._agreements = agreements;
    this._alias = alias;
    this._contacts = contacts;
    this._customerCodeCARA = customerCodeCARA;
    this._domain = domain;
    this._id = id;
    this._nickname = nickname;
    this._password = password;
    this._products = products;
    this._roles = roles;
    this._securityInfo = securityInfo;
    this._subject = subject;
    this._userType = userType;
  }

  get agreements(): Array<AgreementModel> {
    return this._agreements;
  }

  set agreements(value: Array<AgreementModel>) {
    this._agreements = value;
  }

  get alias(): string {
    return this._alias;
  }

  set alias(value: string) {
    this._alias = value;
  }

  get contacts(): Array<ContactModel> {
    return this._contacts;
  }

  set contacts(value: Array<ContactModel>) {
    this._contacts = value;
  }

  get customerCodeCARA(): string {
    return this._customerCodeCARA;
  }

  set customerCodeCARA(value: string) {
    this._customerCodeCARA = value;
  }

  get domain(): string {
    return this._domain;
  }

  set domain(value: string) {
    this._domain = value;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get nickname(): string {
    return this._nickname;
  }

  set nickname(value: string) {
    this._nickname = value;
  }

  get password(): string {
    return this._password;
  }

  set password(value: string) {
    this._password = value;
  }

  get products(): Array<string> {
    return this._products;
  }

  set products(value: Array<string>) {
    this._products = value;
  }

  get roles(): Array<string> {
    return this._roles;
  }

  set roles(value: Array<string>) {
    this._roles = value;
  }

  get securityInfo(): SecurityInfoModel {
    return this._securityInfo;
  }

  set securityInfo(value: SecurityInfoModel) {
    this._securityInfo = value;
  }

  get subject(): SubjectModel {
    return this._subject;
  }

  set subject(value: SubjectModel) {
    this._subject = value;
  }

  get userType(): UserType {
    return this._userType;
  }

  set userType(value: UserType) {
    this._userType = value;
  }
}
